import { Injector, afterNextRender } from '@angular/core';

/**
 * Gives focus back to the room line a special requests dialog was opened from (SRDIALOG-002, R-SDA16): its **Edit** when the room has
 * requests now, else its **+ Special requests** (after a first Save that is the new **Edit**). The button is looked up INSIDE that line,
 * never page-wide - two open reservation cards can each have a Room 1. Runs after the next render, when the opener is enabled again
 * and the line has swapped its button. The shared dynamic modal still opens with `restoreFocus: false`; other dialogs are unchanged.
 */
export function focusRoomLine(line: HTMLElement | null | undefined, injector: Injector): void {
  if (!line) return;
  afterNextRender(
    () => {
      if (!line.isConnected) return;
      const button =
        line.querySelector<HTMLElement>('[data-testid$="-edit"]') ??
        line.querySelector<HTMLElement>('[data-testid$="-add"]');
      button?.focus();
    },
    { injector }
  );
}
